import { Tooltip } from '@shared/components/popover/tooltip';
import { fullCurrencyFormatter } from '@shared/helpers/format-currency';
import { Stat } from '../../../../components/stat';
import { formatCases } from '../../../../helpers/format-quantity';
import type { DealsAggregates } from '../utils/family-aggregates';

type Props = {
  aggregates: DealsAggregates;
};

export function DealsSummaryBanner({ aggregates }: Props) {
  const { cashDeployed, totalSavings, avgSavingsPct, totalCases, familiesCommittedCount } =
    aggregates;
  const label =
    familiesCommittedCount === 0
      ? 'No deals bought yet'
      : `${familiesCommittedCount} ${familiesCommittedCount === 1 ? 'deal' : 'deals'} bought`;

  return (
    <div className="sticky top-0 z-10 border-b border-gray-200 bg-white px-4 py-2 shadow-sm">
      <div className="flex items-center justify-between gap-6">
        <div className="text-xs uppercase tracking-wide text-gray-500">{label}</div>
        <div className="flex gap-6">
          <Stat label="Cases" value={formatCases(totalCases)} />
          <Stat label="Extended" value={fullCurrencyFormatter(cashDeployed)} />
          <Tooltip
            content="Total savings divided by total order value at frontline cost."
            side="bottom"
          >
            <span>
              <Stat label="Savings %" value={`${avgSavingsPct.toFixed(1)}%`} accent />
            </span>
          </Tooltip>
          <Stat label="Savings $" value={fullCurrencyFormatter(totalSavings)} accent />
        </div>
      </div>
    </div>
  );
}
